import { Component, OnInit, Input } from '@angular/core';
import { DID_TYPE } from 'voxloud-types/dist/models';

@Component({
  selector: 'gdp-number-type',
  template: '<div [class]="typeClass">{{type}}</div>'
})
export class NumberTypeComponent implements OnInit {
  @Input('type') type: DID_TYPE;
  public typeClass: string;
  private classMapping = {
    [DID_TYPE.GEOGRAPHIC]: 'vox-chip vox-chip_royal-blue-text text-uppercase',
    [DID_TYPE.TOLL_FREE]: 'vox-chip vox-chip_aquamarine text-uppercase'
  };
  constructor() { }

  ngOnInit() {
    this.typeClass = this.classMapping[this.type];
  }

}
